import React from 'react';
import PropTypes from 'prop-types';

import {
  QuestionLabel,
  Container,
} from '../styles';

const TextQuestionType = (props) => {
  const { label } = props;

  return (
    <Container>
      <QuestionLabel>{label}</QuestionLabel>
    </Container>
  );
};

TextQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
};

export default TextQuestionType;
